import React, { useEffect, useRef, useState } from 'react';
import { Button, CircularProgress, withStyles } from '@material-ui/core';
import { ArrowDropDown, Cancel } from '@material-ui/icons';
import Select from 'react-select';
import componentHeaderStyles from '../../../../../layout/componentHeaderStyles';

const styles = (theme) => {
  const headerStyles = componentHeaderStyles(theme);
  return {
    container: {
      display: 'flex',
      alignItems: 'center',
      gap: '4px'
    },
    inputContainer: {
      paddingRight: 10
    },
    actionButtons: {
      padding: '0 10px',
      borderLeft: `1px solid ${theme.AppBGColor}`,
      cursor: 'pointer',
      marginTop: 6
    },
    button: {
      minHeight: 24,
      fontSize: theme.textFontSize,
      padding: 0,
      textTransform: 'none',
      '&$buttonDisabled': {
        borderColor: theme.HeaderSelectedText,
        cursor: 'not-allowed'
      }
    },
    buttonDisabled: {},
    reactSelect: headerStyles.reactSelect
  };
};

const EditInput = ({ classes, editMode, exitEditMode, gridApi, handleBulkUpdate }) => {
  const [columnOptions, setColumnOptions] = useState([]);
  const [selectedField, setSelectedField] = useState({});
  const [isSaveInProgress, setIsSaveInProgress] = useState(false);
  const editorRef = useRef(null);

  useEffect(() => {
    if (editMode) {
      showEditMode();
    }
  }, [editMode]);

  const showEditMode = () => {
    const columnOptions = gridApi?.getAllGridColumns()
      .filter((col) => col.colDef.editable)
      .map((col) => ({
        label: col.colDef.headerName,
        value: col.colDef.field,
        ...col.colDef
      }));
    const currentField = columnOptions[0];
    setColumnOptions(columnOptions);
    setSelectedField(currentField);
  };

  const saveEdits = async () => {
    let editorValue = '';
    if (editorRef.current) {
      if (editorRef.current.getValue) {
        editorValue = editorRef.current.getValue();
      }
    }

    if (handleBulkUpdate) {
      setIsSaveInProgress(true);
      await handleBulkUpdate({ field: selectedField.value, newValue: editorValue });
      setIsSaveInProgress(false);
      exitEditMode();
    }
  };

  const handleFieldChange = (field) => {
    setSelectedField(field);
  };

  const EditorFramework =  selectedField?.cellEditor || selectedField?.cellEditorFramework;
  let selectStyles = {
    menu: (base) => ({ ...base, zIndex: 2 }) // Set higher z-index to appear above ag-grid group headers
  };
  return (
    <div className={classes.container}>
      <Select
        value={selectedField}
        onChange={handleFieldChange}
        options={columnOptions}
        styles={selectStyles}
        classNamePrefix="select"
        className={classes.reactSelect}
        menuPlacement="auto"
        menuPosition="absolute"
        closeMenuOnSelect
        components={{
          DropdownIndicator: (props) => (
            <ArrowDropDown {...props.innerProps} />
          )
        }}
      />
      {EditorFramework && (
        <div className={classes.inputContainer}>
          <EditorFramework
            ref={(node) => (editorRef.current = node)}
            column={{ colDef: selectedField }}
          />
        </div>
      )}

      <div className={classes.actionButtons}>
        <Button
          variant="outlined"
          size="small"
          color="primary"
          classes={{
            root: classes.button,
            disabled: classes.buttonDisabled
          }}
          onClick={saveEdits}
          disabled={isSaveInProgress}>
          {isSaveInProgress ? <CircularProgress size={16} color="primary" /> : 'Save'}
        </Button>
      </div>

      <div className={classes.actionButtons} onClick={exitEditMode}>
        <Cancel color="primary" />
      </div>
    </div>
  );
};

export default withStyles(styles)(EditInput);
